import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { KpisService } from 'src/app/services/panelM/update-params/kpis.service';
import { CategoriesService } from 'src/app/services/panelM/update-params/categories.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-kpis-admin',
  templateUrl: './kpis-admin.component.html',
  styleUrls: ['./kpis-admin.component.scss']
})
export class KpisAdminComponent implements OnInit {

  params: any;
  paramsKpis: any;
  tab = true;
  search: UntypedFormGroup;
  aux: any;
  placeHolder: string;
  displayedColumns: string[] = ['CategoryCode', 'Description', 'Clout', 'button'];
  displayedColumnsKpis: string[] = ['IdCategory', 'Name', 'Status', 'Clout', 'Value_Top', 'Value_Lower', 'Heart_top',
    'Heart_lower', 'Max_Medium_Score', 'Max_Score', 'Medium_Score', 'Min_Medium_Score', 'Min_Score', 'Value_Medium', 'Value_Medium_Max', 'Value_Medium_Min', 'button'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private kpis: KpisService,
    private categoriesS: CategoriesService,
    private readonly router: Router,
    private snackBar: MatSnackBar,
    private fBuilder: UntypedFormBuilder) { }

  ngOnInit() {
    this.search = this.fBuilder.group({
      result: new UntypedFormControl('', []),
      select: new UntypedFormControl('', [])
    }, {});
    this.categoriesS.categoriesService().subscribe((data: any) => {
      this.params = new MatTableDataSource<any>(data.CategoriesList);
      this.params.paginator = this.paginator;
      this.aux = data.KpiList;
      this.searchItem();
      this.paramsKpis = new MatTableDataSource<any>(this.orderCategory(data.KpiList));
      this.paramsKpis.paginator = this.paginator;
    }, error => {
      console.error(error);
      this.router.navigateByUrl('/portalM');
    });
  }

  searchItem() {
    this.search.valueChanges.subscribe(data => {
      const v = this.search.get('result').value;
      this.placeHolder = data.select;
      if (v === '') {
        this.paramsKpis = new MatTableDataSource<any>(this.orderCategory(this.aux));
        this.paramsKpis.paginator = this.paginator;
        return;
      } else {
        this.paramsKpis = new MatTableDataSource<any>(this.aux.filter(d => d[this.placeHolder].toString().includes(v.trim())));
        this.paramsKpis.paginator = this.paginator;
      }
    });
  }

  updateRowCategorie(element) {
    this.categoriesS.updateCategories(element).subscribe((data: any) => {
      this.smallModal(data);
    }, (data) => {
      this.smallModal(data);
    });
  }

  updateRowKPIs(element) {
    this.kpis.updatekpis(element).subscribe((data: any) => {
      this.smallModal(data);
    }, (data) => {
      this.smallModal(data);
    });
  }

  changeTab(num) {
    if (num === 1) {
      this.tab = true;
    } else {
      this.tab = false;
    }
  }

  /**
   * Muestra un pop up con la información de la actualización
   * @param data: any
   */
  private smallModal(data: any) {
    this.snackBar.open((data.Ok) ? 'Actualización correcta' : 'Error al actualizar', '', {
      duration: 3000,
    });
  }

  /**
   * recibe array de objectos y los devuelve ordenados por IdCategory
   * @param array: any
   */
  private orderCategory(array) {
    for (const e of array) {
      e.IdCategory = e.IdCategory.replace('C', '');
    }
    for (const e of array.sort((a, b) => a.IdCategory - b.IdCategory)) {
      e.IdCategory = (e.IdCategory) ? 'C' + e.IdCategory : e.IdCategory;
    }
    return array;
  }
}
